import { useEffect, useState, PropsWithChildren } from 'react';
import { useInterval } from '~/hooks';
import { INTERNAL_ROUTES } from '~/utils/constants';
import { decodeJwt, hardRedirect } from '~/utils/for-warbler';
import { store } from '~/utils/store';
import { trackEvent, TRACK } from '~/utils/tracking';

export const Token = ({ children }: PropsWithChildren<{}>) => {
  const decoded = decodeJwt(store.get('TOKEN'));
  if (!decoded.valid) store.remove('TOKEN');

  const [expired, setExpired] = useState(decoded.reason === 'expired');
  const shouldRedirect = expired && !location.search.includes('loginToken');

  // if JWT is expired (and no login token in query params), redirect to expired screen and clear store
  useEffect(() => {
    if (shouldRedirect) {
      trackEvent(TRACK.expired);
      store.clearAll();
      hardRedirect(INTERNAL_ROUTES.EXPIRED_SESSION);
    }
  }, [expired]); // eslint-disable-line react-hooks/exhaustive-deps

  // redirect to expired screen if the 2 min interval check finds an expired JWT
  useInterval(() => {
    const decoded = decodeJwt(store.get('TOKEN'));
    if (decoded.reason === 'expired') setExpired(true);
  }, 1000 * 60 * 2);

  return shouldRedirect ? null : <div>{children}</div>;
};
